import React from "react";

export const viewResultTableConstants = (subjectColumns, onViewEvents) => {
  const cols = [
    {
      title: "ID Number",
      key: "id_number",
      render: (row) => row.id_number,
    },
    {
      title: "Name",
      key: "name",
      render: (row) => row.name,
      sortValue: (row) => (row.name || "").toLowerCase(),
    },
    {
      title: "Sr No",
      render: (_row, index) => index + 1,
    },
    {
      title: "Roll No",
      key: "roll_no",
      render: (row) => row.roll_no,
      sortValue: (row) => row.roll_no,
    },
  ];

  subjectColumns.forEach(({ subject_name: subjectName, max_score: subjectMaxScore }) => {
    cols.push({
      title: subjectMaxScore != null ? `${subjectName}(${subjectMaxScore})` : subjectName,
      key: `subject_${subjectName}`,
      className: "text-center",
      sortValue: (row) => {
        const subject = (row.subjects || []).find((s) => s.subject_name === subjectName);
        return subject ? Number(subject.total_marks_obtained) || 0 : -1;
      },
      render: (row) => {
        const subject = (row.subjects || []).find((s) => s.subject_name === subjectName);
        if (!subject) return "-";

        const hasEvents = Array.isArray(subject.events) && subject.events.length > 0;

        return (
          <div
            className={`view-result-cell${hasEvents ? " clickable" : ""}`}
            onClick={hasEvents ? () => onViewEvents(row, subject) : undefined}
            title={hasEvents ? "Click to view marking details" : ""}
          >
            <div>
              {subject.total_marks_obtained}
            </div>
            {subject.grade ? <div><small>{subject.grade}</small></div> : null}
          </div>
        );
      },
    });
  });

  return cols;
};
